import api from "../../index.js";

export const GetIBWalletDetailsApi = () => api.get(`IBMaster/GetIB-WalletDetail`);
export const WithdrawIBCommissionApi = (data) => api.post('IBMaster/IBCommission-Withdrawal', data);
export const GetibWalletApi = (params) => api.get(`IBMaster/GetIB-Wallet-Withdraw-History?${params}`);